import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { convertToDate } from '../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../request-details-files.component";
import Translation from "../../../../../common/translation/translation.component";
import { RequestOnBehalfDetails } from '../.././request-on-behalf-details.component';
import Icons from '../../../../../icon';
import { getRequestUserSessionData as getUserData } from '../../../../../../utils/helpers.utils';
import { REQUEST_STATUS, ORDER_STATUS, CIRCUIT_STATUS } from "../../../../../../constants/external-constants";
import FormatDate from "../../../../../common/date/format-date.component";

export class TerminateSubscriptionDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    render() {
        const { status, data, isWireline, openRequestModal, isAllowUpdate } = this.props;
        const {Order: { RequestType: { RequestTypeID, RequestType } }} = data || {};
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                
                {isAllowUpdate() ?  
                          <Icons
                          customClassName="pen-to-square"
                          name="pen-to-square"
                          size="20px"
                          containerClass="icon-circle-plus-container"
                          onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                          labelValue={"Update Order Request"}
                          labelClass="order-detail-edit-label"                                                              
                        />

                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>
                    {data.Order.IsRequestedInBehalf ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.PlanDetails.PlanName ?
                                    data.Subscription.PlanDetails.PlanName :
                                    <Translation translationKey="no_plan_available" />}</td>
                            </tr>

                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="terminate_request_details" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="terminate_date" /></td>
                                <td>
                                    <FormatDate date={convertToDate(data.Order.OrderDisconnectDate)} />
                                </td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}